/*
 * Gatsby Advertorial — Calming Nature
 * Minimal vanilla JS. No deps.
 * Handles: tabs (PROBLEM/SHIFT/RESET), product-carousel dots, sticky CTA visibility.
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    initTabs();
    initCarousel();
    initStickyChip();
    killTrackingWidget();
    // Re-run tracking-widget killer periodically — app may inject after our first sweep
    setInterval(killTrackingWidget, 1500);
  });

  // ---------- Kill JS-injected order-tracking widget ----------
  // The widget has no stable selector — match by content phrases unique to shipment timelines.
  function killTrackingWidget() {
    var phrases = [
      'Delivery progress',
      'International flight has departed',
      'Arrived at the origin international airport',
      'Shipment is in transit',
      'Departed from sort facility',
      'Mainland China',
      'Shipping Label Created',
      'Shipment information received'
    ];
    // Walk all elements and find the highest ancestor whose textContent contains the phrase
    // but only the phrase (i.e. a focused tracking widget, not our whole page).
    var candidates = document.querySelectorAll('div, section, aside, article');
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (!el || !el.parentNode) continue;
      // Skip our own advertorial
      if (el.closest && el.closest('.cn-adv')) continue;
      var t = (el.textContent || '').trim();
      if (!t || t.length > 2500) continue;
      var hits = 0;
      for (var p = 0; p < phrases.length; p++) {
        if (t.indexOf(phrases[p]) !== -1) hits++;
        if (hits >= 2) break;
      }
      if (hits >= 2) {
        try { el.parentNode.removeChild(el); } catch (e) {}
      }
    }
  }

  // ---------- Tabs (PROBLEM / SHIFT / RESET) ----------
  function initTabs() {
    var wraps = document.querySelectorAll('[data-tabs]');
    wraps.forEach(function (wrap) {
      var tabs = wrap.querySelectorAll('.cn-tabs__tab');
      var panels = wrap.querySelectorAll('.cn-tabs__panel');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var name = tab.getAttribute('data-tab');
          tabs.forEach(function (t) {
            var isActive = t === tab;
            t.classList.toggle('is-active', isActive);
            t.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            p.classList.toggle('is-active', p.getAttribute('data-panel') === name);
          });
        });
      });
    });
  }

  // ---------- Product carousel: dots ↔ scroll sync ----------
  function initCarousel() {
    var carousels = document.querySelectorAll('[data-carousel]');
    carousels.forEach(function (carousel) {
      var slidesWrap = carousel.querySelector('[data-carousel-slides]');
      var dots = carousel.querySelectorAll('[data-carousel-dots] button');
      if (!slidesWrap || !dots.length) return;

      var slides = slidesWrap.children;
      var raf = null;

      // Click a dot → scroll to slide
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var idx = parseInt(dot.getAttribute('data-dot'), 10);
          if (slides[idx]) {
            slidesWrap.scrollTo({
              left: slides[idx].offsetLeft,
              behavior: 'smooth'
            });
          }
        });
      });

      // Scroll → update dot
      slidesWrap.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          var w = slidesWrap.clientWidth;
          if (!w) { raf = null; return; }
          var idx = Math.round(slidesWrap.scrollLeft / w);
          dots.forEach(function (d, i) {
            d.classList.toggle('is-active', i === idx);
          });
          raf = null;
        });
      });
    });
  }

  // ---------- Sticky chip: hide near the very top so it doesn't overlap the hero CTA ----------
  function initStickyChip() {
    var chip = document.querySelector('[data-sticky]');
    if (!chip) return;
    var hideThreshold = 400; // px from top

    function update() {
      if (window.scrollY < hideThreshold) {
        chip.style.opacity = '0';
        chip.style.pointerEvents = 'none';
        chip.style.transform = 'translateY(20px)';
      } else {
        chip.style.opacity = '1';
        chip.style.pointerEvents = 'auto';
        chip.style.transform = 'translateY(0)';
      }
    }

    chip.style.transition = 'opacity 0.2s ease, transform 0.25s ease';
    update();
    window.addEventListener('scroll', update, { passive: true });
  }
})();
